import React from "react";
import AddInfo from "./AddInfo";

function FloatRight() {
  return (
    <div className="d-flex align-items-center">
      <AddInfo />
    </div>
  );
}

export default FloatRight;
